import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import BreakOnNewline from 'lib/tags/break-on-newline'

import Translate from './translate'

import courseLogic from '~/scenes/course/show/logic'

const edit = url => (
  <div>
    <a href={url}>{I18n.t('profiles.show_info.edit')}</a>
  </div>
)

export const DumbAboutTeacher = ({ profileEditUrl, teacherDescription, teacherEducation, teacherExperience }) => {
  if (!profileEditUrl && !teacherDescription && !teacherEducation && !teacherExperience) {
    return null
  }

  return (
    <div className='widget space' id='teacher_info'>
      {teacherDescription || profileEditUrl ? (
        <div className='info-block'>
          <h2>{I18n.t('profiles.show_info.description')}</h2>
          <Translate />
          {teacherDescription ? <BreakOnNewline text={teacherDescription} /> : edit(profileEditUrl)}
        </div>
      ) : null}

      {teacherEducation || profileEditUrl ? (
        <div className='info-block'>
          <h2>{I18n.t('profiles.show_info.education')}</h2>
          <Translate />
          {teacherEducation ? <BreakOnNewline text={teacherEducation} /> : edit(profileEditUrl)}
        </div>
      ) : null}

      {teacherExperience || profileEditUrl ? (
        <div className='info-block'>
          <h2>{I18n.t('profiles.show_info.experience')}</h2>
          <Translate />
          {teacherExperience ? <BreakOnNewline text={teacherExperience} /> : edit(profileEditUrl)}
        </div>
      ) : null}
    </div>
  )
}

const AboutTeacher = () => {
  const {
    course: { profileEditUrl, teacherDescription, teacherEducation, teacherExperience }
  } = useValues(courseLogic)

  return (
    <DumbAboutTeacher
      profileEditUrl={profileEditUrl}
      teacherDescription={teacherDescription}
      teacherEducation={teacherEducation}
      teacherExperience={teacherExperience}
    />
  )
}

DumbAboutTeacher.propTypes = {
  profileEditUrl: PropTypes.string,
  teacherDescription: PropTypes.string,
  teacherEducation: PropTypes.string,
  teacherExperience: PropTypes.string
}

export default AboutTeacher
